export default "__VITE_ASSET__Ci95gBu___"